import request from './request.js';
import {requestbody} from './request.js'
// 政策知识库分页查询
export async function zcfg_fycx (params = {
}) {
return await requestbody('wiki/policy/page', 'post', params)
}
//税务政策新增
export async function zcfg_zcxz (params = {
}) {
return await requestbody('wiki/policy/save', 'post', params)
}

//删除税务信息
export async function zcfg_delete (params = {
}) {
return await requestbody('wiki/policy/delete', 'post', params)
}
//查看税务信息
export async function zcfg_fetch (params = {
}) {
return await requestbody('wiki/policy/fetch', 'post', params)
}

//税务政策文件上传
export async function zcfg_upload (params = {
}) {
    return await request('wiki/policy/upload', 'post', params)
}
//删除上传文件
export async function zcfg_deletescwj (params = {
}) {
    return await request('wiki-policy-file/delete', 'post', params)
}


export async function policypage (params = {
}) {
    return await request('/policy-tag/page', 'get', params)
}

export async function update (params = {
}) {
    return await requestbody('/policy-tag/update', 'post', params)
}

export async function tagdelete (params = {
}) {
    return await request('/policy-tag/delete', 'post', params)
}

export async function tagsave (params = {
}) {
    return await requestbody('/policy-tag/save', 'post', params)
}


